<template>
  <div class="infoPostModelSectionSelectionDv" v-if="post && post.sectionData">
    <div class="innerPostModelDv">
      <div class="header">
        <!-- <h2>
          <IconComponent class="iconinfoLeftDv" icon="icon-section.svg" />
          {{ post.sectionData.name }}
        </h2> -->
        <h2 v-if="post.sectionData.name === 'Favorite Investments'">
          <IconComponent class="iconinfoLeftDv" icon="icon-section.svg" />
          {{ $t("common.common.favorite_symbols") }}
        </h2>
        <h2 v-else>
          <IconComponent class="iconinfoLeftDv" icon="icon-section.svg" />
          {{ post.sectionData.name }}
        </h2>
      </div>
      <div class="body">
        <template v-if="post.sectionData.type === 'topStats'">
          <el-scrollbar>
            <div class="StatsGridSectionSelectionDv topStats">
              <div
                class="StastItemSectionSelectionDv"
                v-for="stat in post.sectionData.data"
                :key="stat"
              >
                <TopStatItemComponent
                  :fromPopup="true"
                  :stat="stat"
                  :fromOutside="fromOutside"
                />
              </div>
            </div>
          </el-scrollbar>
        </template>
        <template v-if="post.sectionData.type === 'favouriteInvestment'">
          <el-scrollbar>
            <div class="StatsGridSectionSelectionDv favouriteInvestmentStat">
              <div
                class="StastItemSectionSelectionDv"
                v-for="item in post.sectionData.data"
                :key="item"
              >
                <StockItemWidget
                  :stockData="item"
                  :key="item"
                  :disableRouting="false"
                />
              </div>
            </div>
          </el-scrollbar>
        </template>
        <template v-if="post.sectionData.type === 'portfolio'">
          <el-scrollbar>
            <div class="StatsGridSectionSelectionDv portfolio">
              <div
                class="StastItemSectionSelectionDv"
                v-for="item in post.sectionData.data"
                :key="item"
              >
                <PortfolioItem :portfolioData="item" />
              </div>
            </div>
          </el-scrollbar>
        </template>
        <template v-if="post.sectionData.type === 'links'">
          <el-scrollbar>
            <div class="StatsGridSectionSelectionDv links">
              <div
                class="StastItemSectionSelectionDv"
                v-for="item in post.sectionData.data"
                :key="item"
              >
                <LinksItem
                  class="linkitemCardWidthDv"
                  :trade="item"
                  :key="item"
                />
              </div>
            </div>
          </el-scrollbar>
        </template>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import TopStatItemComponent from "../../../profile-screen/components/TopStatsComponent/TopStatItemComponent.vue";
import StockItemWidget from "../../../profile-screen/components/FavouriteInvestment/StockItemWidget.vue";
import PortfolioItem from "../../../profile-screen/components/PortfolioComponent/PortfolioItem.vue";
import LinksItem from "../../../profile-screen/components/LinksComponent/LinksItem.vue";

export default defineComponent({
  props: ["post", "fromOutside"],
  components: {
    TopStatItemComponent,
    LinksItem,
    PortfolioItem,
    StockItemWidget,
  },
  setup(props, context) {
    onMounted(() => {});
    return {};
  },
});
</script>
<style lang="scss" scoped>
.iconDvSignalPostCreate {
  position: absolute;
  z-index: 9;
  top: -5px;
  right: -5px;
  width: 18px;
  height: auto;
  cursor: pointer;
}
.post_detail {
  .infoPostModelSectionSelectionDv {
    .innerPostModelDv {
      .body {
        .StatsGridSectionSelectionDv {
          .statsGridSectionScrollable {
            max-height: calc(100vh - 240px) !important;
          }
        }
      }
    }
  }
}

.infoPostModelSectionSelectionDv {
  background: var(--base-dark);
  // padding: 15px;
  border-radius: 10px;

  &.post-profile-section {
    max-width: 80%;
    flex: 0 0 80%;
    width: 80%;
    margin: auto;
    height: calc(100% - 100px);
    box-sizing: border-box;
    background: var(--base-dark);

    .innerPostModelDv {
      overflow: auto;
      @include newScrollbar;
      background: transparent;
      height: 100%;
      width: 100%;
      box-sizing: border-box;
    }
  }

  .innerPostModelDv {
    background: var(--base-dark);
    padding: 15px;
    border-radius: 10px;

    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0px 0px 15px;

      h2 {
        display: flex;
        align-items: center;
        gap: 10px;
        color: var(--grey-color);
        font-weight: 600;
        font-size: var(--font-2sm);

        @media (min-width: 1280px) and (max-width: 1891px) {
          font-size: var(--font-2xs);
        }

        margin: 0 0 0px;

        span {
          stroke: var(--grey-color);
          height: 22px;
          width: 22px;
          opacity: 0.5;

          @media (min-width: 1280px) and (max-width: 1891px) {
            height: 16px;
            width: 16px;
          }
        }
      }

      h3 {
        background: #e91b9b;
        color: var(--base-text-white);
        width: 72px;
        height: 28px;
        border-radius: 7px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        line-height: 1;
        letter-spacing: 0px;
        margin: 0px;
        padding: 0px;
        font-weight: 400;
      }
    }

    .body {
      margin: 0px !important;

      .StatsGridSectionSelectionDv {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0px 20px;
        gap: 15px;
        flex-flow: wrap;

        .StastItemSectionSelectionDv {
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }

        &.favouriteInvestmentStat {
          max-height: 350px;

          .StastItemSectionSelectionDv {
            width: var(--stock-item-widget-width);
            flex: 0 0 var(--stock-item-widget-width);
            max-width: var(--stock-item-widget-width);
          }
        }

        &.links {
          @media (min-width: 1280px) and (max-width: 1891px) {
            padding-inline: 0;

            .StastItemSectionSelectionDv {
              width: 100%;
              flex: 0 0 100%;
              max-width: 100%;
            }
          }
        }

        &.topStats {
          max-height: 340px;
          width: 100%;

          .StastItemSectionSelectionDv {
            width: 185px;
            flex: 0 0 185px;
            max-width: 185px;

            @media (min-width: 1280px) and (max-width: 1891px) {
              width: var(--stock-item-widget-width);
              flex: 0 0 var(--stock-item-widget-width);
              max-width: var(--stock-item-widget-width);

              .stat_item {
                width: var(--stock-item-widget-width);
                flex: 0 0 var(--stock-item-widget-width);
                max-width: var(--stock-item-widget-width);
              }
            }
          }
        }

        &.portfolio {
          max-height: 300px;

          .StastItemSectionSelectionDv {
            flex: 0 0 150px;
            max-width: 150px;
            width: 150px;
          }
        }

        &.links {
          max-height: 330px;
        }

        &.scrollbar {
          overflow-y: auto;
          overflow-x: hidden;
          @include scrollbar;
        }
      }
    }
  }
}

.box_detail_container {
  .infoPostModelSectionSelectionDv {
    .innerPostModelDv {
      .body {
        .StatsGridSectionSelectionDv {
          &.scrollbar {
            max-height: none;
          }
        }
      }
    }
  }
}

.linkitemCardWidthDv {
  flex: 0 0 315px;
  max-width: 315px;
  width: 315px;
  height: 53px !important;

  @media (min-width: 1280px) and (max-width: 1891px) {
    flex: 0 0 100%;
    max-width: 100%;
    width: 100%;
  }
}
</style>
